const pad = (n) => String(n).padStart(2, "0");

// Primeiro e último dia do mês (mês 1-12) como "yyyy-MM-dd".
export function monthRange(year, month) {
  const lastDay = new Date(year, month, 0).getDate();
  return { de: `${year}-${pad(month)}-01`, ate: `${year}-${pad(month)}-${pad(lastDay)}` };
}
